import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BusinessAccountsService } from '../business-accounts.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-new-business-hero-header',
  templateUrl: './new-business-hero-header.component.html',
  imports: [
    CommonModule, 
    TalkToSalesButtonComponent,
    UrlParamsPipe
  ],
})
export class NewBusinessHeroHeaderComponent implements OnInit, OnDestroy {
  @ViewChild('registerLink') registerLink: any;
  @Input() queryParams: any;
  newBusinessHeroHeader:any;
  backgroundImageUrl:any;
  highlightedText:any;
  constructor(private businessAccountsService: BusinessAccountsService) {
    this.subscriptions = [];
  }

  subscriptions: Subscription[];
  ngOnInit(): void {
    this.businessAccountsService.newBusiness$.subscribe(data => {
      if (data != null) {
        this.newBusinessHeroHeader = data;
        this.highlightedText = this.newBusinessHeroHeader.title.replace(
          /Multi-Currency Account/g,
          '<span class="moonstone">Multi-Currency Account</span>'
        );
        this.backgroundImageUrl = `url(${data.image[1]?.fields?.file?.url})`;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
  openRegisterLink(event:any, target?:string) {
    event.preventDefault();
    const link = this.registerLink.nativeElement.href;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_blank');
  }
}
